// import './__plugins__/axios/index.js'
// import './__JS__/common.js'
// import './__JS__/plugins/loadingAnimation.js'
// import './__JS__/permissionsNumber.js'
// import './__COMPONENTS__/tooltip/src/main.js'
// import './__COMPONENTS__/message/src/main.js'
// import './__COMPONENTS__/message-box/src/main.js'
// import './__COMPONENTS__/notification/src/main.js'
// import './__JS__/commonCallbacks.js'
// import './__JS__/common/auth.js'
// import './__JS__/common/obsupload.js'
// import './__JS__/common/imgpreview.js'
// import './__JS__/jufaAI/modules/ai_config.js'
// import './__JS__/jufaAI/modules/ai_utils.js'
// import './__JS__/jufaAI/core/client.js'
// import './__JS__/jufaAI/core/process.js'
// import './__JS__/jufaAI/core/render.js'
// import './__JS__/jufaAI/core/session.js'
// import './__JS__/jufaAI/core/message.js'
// import './__JS__/jufaAI/features/index.js'
// import './__JS__/jufaAI/features/selectMenu.js'
// import './__JS__/jufaAI/ai_main.js'
// import './__JS__/jufaAI/modules/ai_modal.js'
// import './__JS__/jufaAI/modules/ai_upload.js'
// import './__JS__/jufaAI/modules/ai_questionHandler.js'
// import './__JS__/jufaAI/modules/ai_history.js'
// import './__JS__/jufaAI/modules/ai_docQuestion.js'
// import './__JS__/jufaAI/modules/ai_quote.js'
// import './__JS__/jufaAI/modules/ai_hlTextPopup.js'

import ResizeObserver from "resize-observer-polyfill";
import PinyinMatch from './headerSearchForm/pinyin.js'

window.ResizeObserver = ResizeObserver;
window.PinyinMatch = PinyinMatch;

import './headerSearchForm/Hooks/useZIndex.js'
import './headerSearchForm/Hooks/useEmitter.js'
import './headerSearchForm/Hooks/useThrottle.js'
import './headerSearchForm/Hooks/useDebounce.js'

import './headerSearchForm/DropdownProxy/index.js'

import './headerSearchForm/Message/index.js'
import './headerSearchForm/Message/index.css'

import './headerSearchForm/Checkbox/index.js'
import './headerSearchForm/Checkbox/index.css'

import './headerSearchForm/CheckboxGroup/index.js'
import './headerSearchForm/CheckboxGroup/index.css'

import './headerSearchForm/Radio/index.js'
import './headerSearchForm/Radio/index.css'

import './headerSearchForm/RadioGroup/index.js'
import './headerSearchForm/RadioGroup/index.css'

import './headerSearchForm/TreeTransfer/index.js'
import './headerSearchForm/TreeTransfer/index.css'

import './headerSearchForm/Dialog/index.js'
import './headerSearchForm/Dialog/index.css'

import './headerSearchForm/MultipleDropdown/index.js'
import './headerSearchForm/MultipleDropdown/index.css'

import './headerSearchForm/Cascader/index.js'
import './headerSearchForm/Cascader/index.css'

import './headerSearchForm/Dropdown/index.js'
import './headerSearchForm/Dropdown/index.css'

import './headerSearchForm/CascaderDropdown/index.js'
import './headerSearchForm/CascaderDropdown/index.css'

import './headerSearchForm/Tooltip/index.js'
import './headerSearchForm/Tooltip/index.css'

import './headerSearchForm/Confirm/index.js'
import './headerSearchForm/Confirm/index.css'

import './headerSearchForm/headerSearchForm.js'
import './headerSearchForm/headerSearchForm.css'
